import React from "react";
import "./RoadTransport.css";
import Arab from "../../../../../Image/Arab.png";
import Dubai from "../../../../../Image/dubai.png";
import footprint from "../../../../../Image/footprint.png";
import useFetch from "../../../../../hooks/useFetch";

const Open = () => {
  const { data } = useFetch("https://abc-backend.onrender.com/api/quotes");
  return (
    <div className="tabelMain">
      {data &&
        data?.map((item, i) => (
          <>
            {!item?.saveDrfat && item.open && (
              <div className="card" style={{ marginBottom: "20px" }} key={i}>
                <div className="card-heading card-heading1">
                  <div>
                    <h5>ID</h5>
                  </div>
                  <div>
                    <h5 className="countryTitle">
                      {item?.data?.loadingUnDetailsValue[0]?.locationFrom}
                      {"  "}
                      {item?.data?.loadingUnDetailsValue[0]?.locationTo}
                    </h5>
                  </div>
                </div>
                <div className="card-heading">
                  <div>
                    <h5> 100001</h5>
                    <h5>13-Sep-2022 07:05</h5>
                    <h5>{item?.data?.quoteIntValue?.transportationType}</h5>
                  </div>
                  <div>
                    <h6>Services:</h6>
                    <h6>Product:</h6>
                    <h6>Loading Date:</h6>
                  </div>
                  <div>
                    <h5>Road Transportation</h5>
                    <h5>{item?.data?.quoteIntValue?.productType}</h5>
                    <h5>{item?.data?.quoteIntValue?.loadDate}</h5>
                  </div>
                  <div className="footprint_img">
                    <img src={footprint} alt="footprint" />
                    <span>100 g</span>
                  </div>
                </div>
                {item?.data?.loadingUnDetailsValue.map((lcData, i) => (
                  <div className="card-heading" key={i}>
                    <div>
                      <h5> {lcData?.locationFrom}</h5>
                      <h6 className="country"> {lcData?.locationFrom}</h6>
                      <img width="40" height="25" src={Dubai} alt="" />
                      <h5>Pickup</h5>
                    </div>
                    <div>
                      <h5>{lcData?.locationTo}</h5>
                      <h6 className="country">{lcData?.locationTo}</h6>
                      <img width="40" height="25" src={Arab} alt="" />
                      <h5>Destination</h5>
                    </div>
                  </div>
                ))}
                <div className="user_dashboard_line"></div>
              </div>
            )}
          </>
        ))}
      {data?.length < 0 && <h2 style={{ height: "100vh" }}>No Quote Found</h2>}
    </div>
  );
};

export default Open;
